import { theme } from '@features/lci-report/domain/theme';
import { TextPropsTextConfig } from '@features/powerpoint';

type CalculationEntryProps = {
  label: string;
  definition: string | undefined;
};

export const calculationEntry = (
  props: CalculationEntryProps
): TextPropsTextConfig[] => {
  return [
    {
      text: props.label,
      options: {
        breakLine: true,
        color: theme.colors.inmarketGreen,
      },
    },
    {
      text: props.definition,
      options: { breakLine: true },
    },
  ];
};
